module.exports = __webpack_public_path__ + "static/media/404.2b2e213f.png";